import React, { useEffect, useState, useMemo, useRef } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

export default function BetDetailsPopup() {
  const { transid } = useParams();
  const [data, setData] = useState(null);
  const [summarydata, setSummaryData] = useState(null);
  const [Dealer, setDealer] = useState("");

  useEffect(() => {
    const fetchBetDetails = async () => {
      const response = await axiosInstance.get(`master/bet-detail/${transid}`);
      console.log("BET API RESPONSE:", response.data);
      setSummaryData(response.data.bet);

      setData(response.data.bet.betList);
      setDealer(response.data.bet.dealer);
      setIsLoading(false);
    };
    fetchBetDetails();
  }, []);

  const getType = (data) => {
    if (data == "L" || data == "l" || data == "N" || data == "n") {
      return `<strong>L</strong>`;
    } else {
      return `<strong>B</strong>`;
    }
    //return `<strong>${data}</strong>`;
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);

  const loadingRef = useRef(false);
  const gridTableRef = useRef(null);
  const defaultExpand = true;
  let marketType;
  const cols = useMemo(
    () => [
      {
        title: "Runner",
        data: "rnrsid",
        responsivePriority: 1,
        render: (d, type, row, meta) => {
          let splitRnr = d.split("-");
          let rnrVal = splitRnr[1];
          let runnerName = "";
          if (marketType == 23) {
            runnerName = row.rnr;
          } else if (marketType == 15) {
            runnerName = row.rnr;
          } else if (marketType == 13) {
            runnerName = row.rnr;
          } else if (marketType == 25) {
            runnerName = row.rnr;
          } else if (marketType == 16) {
            runnerName = row.rnr;
          } else if (marketType == 24) {
            runnerName = row.rnr;
          } else if (marketType == 17) {
            runnerName = row.rnr;
          } else if (marketType == 18) {
            runnerName = row.rnr;
          } else if (marketType == 26) {
            runnerName = row.rnr;
          } else if (marketType == 11) {
            runnerName = row.rnr;
          }
          return `
          <div class="d-flex align-items-center justify-content-between">
            <span>${runnerName}</span>
            <button type="button" class="toggle-row toggle-closed" style="margin-left:8px;">+</button>
          </div>`;
        }
      },

      {
        title: "Runner",
        data: "section",
        responsivePriority: 1,
        render: (d, type, row, meta) => {
          /*console.log("Runner Column Row Data:", row);
          console.log("Runner Column Value:", d);
          console.log("Row Index:", meta.row);
          console.log("ROW DATA:", row);
          console.log("FIELDS:", Object.keys(row));*/
          console.log(row.runnerName || row.rname || row.section);
          return `
    <div class="d-flex align-items-center justify-content-between">
      <span>${d ?? ""}</span>
      <button type="button" class="toggle-row toggle-closed" style="margin-left:8px;">+</button>
    </div>
  `;
        }
      },

      {
        title: "Price",
        data: "amnt",
        render: (d) => (d != null ? Number(d)?.toFixed(2) : "")
      },
      {
        title: "Size",
        data: "rate",
        render: (d) => (d != null ? d : "")
      },
      {
        title: "Side",
        data: "type",
        createdCell: (td, val) => {
          if (val === "L" || val === "l") {
            $(td).css({
              background: "#dc3545",
              color: "white",
              textAlign: "center",
              fontWeight: "700"
            });
          } else {
            $(td).css({
              background: "#28a745",
              color: "white",
              textAlign: "center",
              fontWeight: "700"
            });
          }
        },
        render: (d) => getType(d)
      },
      {
        title: "P/L",
        data: "lib",
        createdCell: (td, cellData, rowData) => {
          const val = rowData.type === "L" ? rowData.lib : rowData.pro;
          if (val < 0) {
            $(td).css({
              background: "#f8d7da",
              color: "#842029",
              fontWeight: 600,
              textAlign: "right"
            });
          } else {
            $(td).css({
              background: "#d1e7dd",
              color: "#0f5132",
              fontWeight: 600,
              textAlign: "right"
            });
          }
        },
        render: (d, type, row) => {
          const val = row.type.toUpperCase() === "L" ? row.lib : row.pro;

          return `<span>${val?.toFixed(2)}</span>`;
        }
      },
      {
        title: "Placed At",
        data: "stmp",
        render: (d) => `<span>${moment(d).format("YYYY-MM-DD HH:mm:ss")}</span>`
      },
      {
        title: "Settled At",
        data: null,
        render: () => {
          return `<span>${moment(summarydata?.created_date).format(
            "YYYY-MM-DD HH:mm:ss"
          )}</span>`;
        }
      },
      {
        title: "Order Id",
        data: "id",
        render: (d) => `<strong>${d ?? ""}</strong>`
      },
      {
        title: "Customer",
        data: null,
        render: () => `<strong>${summarydata?.uname ?? ""}</strong>`
      },
      {
        title: "Dealer",
        data: null,
        render: () => `<strong>${Dealer ?? ""}</strong>`
      },
      {
        title: "FullOdds",
        data: null,
        render: () => `
      <strong>
        <span>440</span>@<span style="color:blue">1.02</span> -
        <span>5070</span>@<span style="color:blue">1.01</span> =
        <span>1567</span>@<span style="color:red">1.03</span> -
        <span>3476</span>@<span style="color:red">1.04</span> -
        <span>2757</span>@<span style="color:red">1.05</span>
      </strong>
    `
      },
      {
        title: "",
        data: "pro",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 3
      }
    ],
    [summarydata]
  );

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !data.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe data (only include referenced keys + seq)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (data || []).map((row, i) => {
      const out = { seq: i + 1 }; // seq is initial placeholder; will be updated after draw
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });
      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: { details: false },
        pageLength: pageSize || 10,
        lengthChange: false,
        autoWidth: false,
        ordering: true,
        order: initialOrder,
        columnDefs: [{ targets: 0, orderable: false }], // safeguard
        dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',

        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false,
        rowCallback: function (row, data, index) {
          // Mobile breakpoint (same as your CSS media query)
          const isMobile = window.matchMedia("(max-width:640px)").matches;

          if (isMobile) {
            // single dark color for every main row on mobile
            $(row).css({
              "background-color": "#f7f7f7", // dark row background
              color: "" // light text
            });
          } else {
            // Desktop: keep zebra striping you had previously
            $(row).css({
              "background-color": index % 2 === 0 ? "#f7f7f7" : "#ffffff",
              color: "" // let default text color apply
            });
          }
        }
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)

    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";

      hiddenCols.forEach((i) => {
        const col = dt.column(i);

        if (!col || !col.header()) return;

        const title = $(col.header()).text();
        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        // Using the same render() as parent column
        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        html += `
      <tr>
        <td style="width:40%;border-top:0;border-left:0;border-right:0;border-bottom:1px solid #eee;">
          <span style="font-weight:bold;">${title}</span> 
          ${rendered}
        </td>
      </tr>`;
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(`<table class="table table-sm mb-0">${details}</table>`)
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // Initial numbering (after initial draw)
    requestAnimationFrame(() => {
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, data, pageSize, defaultExpand, isLoading]);
  return (
    <>
      <div className="animated fadeIn" style={{ margin: 0 }}>
        <div className="container-fluid p-0">
          {/* small style overrides are added below using a standard <style> element */}
          <div className="row w-100 m-0">
            <div className="col-12 p-0">
              <div className="card">
                <div className="card-header">
                  <h5 className="m-0 d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      style={{ background: "#337ab7" }}
                      onClick={() => {
                        window.history.back();
                        return false;
                      }}
                    >
                      Back
                    </button>
                    <span
                      style={{ paddingLeft: 10, fontSize: 20 }}
                      id="TopTitle"
                    >
                      {summarydata?.result}
                    </span>
                  </h5>
                </div>

                <div className="card-body">
                  <table className="table summary-table mb-3">
                    <tbody>
                      <tr>
                        <th>
                          Winner
                          <span
                            className="badge badge-warning ml-2"
                            style={{
                              fontSize: "100%",
                              background: "#ffc403",
                              color: "black",
                              padding: 4,
                              borderRadius: 4
                            }}
                          >
                            {summarydata?.result}
                          </span>
                        </th>
                        <th>
                          Net PL
                          <span
                            id="win_amt"
                            className={
                              summarydata?.win_amount < 0
                                ? "badge badge-danger bg-danger ml-2"
                                : "badge badge-success bg-success ml-2"
                            }
                            style={{
                              fontSize: "100%",
                              color: "white",
                              padding: 4,
                              borderRadius: 4
                            }}
                          >
                            {formatTruncate(summarydata?.win_amount)}
                          </span>
                        </th>
                        <th>
                          Username
                          <span
                            className="badge badge-warning ml-2"
                            style={{
                              fontSize: "100%",
                              background: "#ffc403",
                              color: "black",
                              padding: 4,
                              borderRadius: 4
                            }}
                          >
                            {summarydata?.uname}
                          </span>
                        </th>
                      </tr>
                    </tbody>
                  </table>

                  <div className="datatable-wrapper">
                    <table
                      ref={gridTableRef}
                      className="table table-striped table-bordered dataTable no-footer dtr-inline display mt-2"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          {cols.map((c) => (
                            <th key={String(c.data || c.title)}>{c.title}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody />
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SAFE CSS (no dangerouslySetInnerHTML) */}
      <style>{`
        .table { width: 100% !important; }
        .table.table-striped td, .table.table-striped th {
          padding: 6px 8px !important;
          font-size: 16px;
          white-space: normal !important;
          vertical-align: middle;
        }
        .toggle-row {
          border: none;
          cursor: pointer;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          font-weight: 700;
          font-size: 14px;
          color: #fff;
          background:#28a745;
          display:flex;
          align-items:center;
          justify-content:center;
        }
        .toggle-open { background:#dc3545 !important; }
        .summary-table th { text-align:left; border: 0; padding: 0.25rem 0; }
        @media (max-width: 640px) {
          .summary-table th { display:block; width:100%; white-space:normal; font-size:14px; }
          .table.table-striped td, .table.table-striped th { font-size:14px !important; padding:6px 6px !important; }
        }
      `}</style>
    </>
  );
}
